import { render, staticRenderFns } from "./OrderStatusSelector.vue?vue&type=template&id=f1e3e5aa&class=orderStatusSelector%20oss"
import script from "./OrderStatusSelector.vue?vue&type=script&lang=js"
export * from "./OrderStatusSelector.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusSelector.vue?vue&type=style&index=0&id=f1e3e5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports